<app-reactive-dialog-content [data]="dialogInputData">
  <div class="flex-container">
    <div>
      <app-spacer></app-spacer>
      <div class="center">
        <mat-button-toggle-group name="mailPrintSelection" aria-label="Auswahl" [formControl]="typeSelection">
          <mat-button-toggle [value]="'mail'">E-Mail</mat-button-toggle>
          <mat-button-toggle [value]="'print'">Papier</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <app-spacer></app-spacer>
      <div class="textbox" *ngIf="type === 'print'">
        <div class="texticon">
          <mat-icon color="accent">info_outline</mat-icon>
        </div>
        <div class="message">
          {{ infotext }}
        </div>
      </div>
      <app-spacer></app-spacer>
      <!-- mail -->
      <ng-container *ngIf="type === 'mail'">
        <div *ngIf="personId" class="person-send">
          <div class="send-text">
            <span>Senden an: </span>
            <div class="fat-text">
              {{ ' ' + personname }}
            </div>
          </div>
          <button mat-icon-button (click)="onEditKunde()">
            <mat-icon color="primary">create</mat-icon>
          </button>
        </div>
        <form #ngForm="ngForm" class="besichtigung-form">
          <div>
            <mat-form-field class="select-control">
              <mat-label>Auswahl</mat-label>
              <mat-select [formControl]="emailDropdown">
                <mat-option [value]="null">
                  <hr>
                </mat-option>
                <mat-option *ngFor="let option of emailOptions$ | async" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="besichtigung-input">
            <app-basic-input [styleClass]="'email-control'" [name]="'email'" label="E-Mail" [hideErrorText]="false"
                             [(ngModel)]="email" [validatorConfig]="emailValidator">
            </app-basic-input>
          </div>
        </form>
      </ng-container>
      <!-- print -->
      <ng-container *ngIf="type === 'print'">
        <div class="scrollable linkbox" *ngIf="files && files.length > 0">
          <mat-list>
            <mat-list-item *ngFor="let file of files">
              <mat-icon class="mat-24 clickable" matListItemIcon (click)="!!openFile(file)">picture_as_pdf</mat-icon>
              <p matListItemTitle>
                <a (click)="!!openFile(file)" href="#">{{ file.key }}</a>
              </p>
            </mat-list-item>
          </mat-list>
        </div>
      </ng-container>
    </div>
    <div>
      <app-basic-checkbox label="{{confirmationText}}" [(ngModel)]="confirmation">
      </app-basic-checkbox>
      <app-spacer></app-spacer>
      <button mat-raised-button [disabled]="sendRunning || !confirmation" color="accent" class="button-right-margin"
              (click)="onConfirmClick()">
        {{ type === 'mail' ? 'Senden' : 'OK' }}
      </button>
      <button mat-raised-button class="mat-gray-bg" (click)="onCancelClick()">Abbrechen</button>
    </div>
  </div>
</app-reactive-dialog-content>
